(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxContentWidgetViewNonVisual', {
		bindings: { parameters: '=?' },
		controller: MxContentWidgetViewNonVisualCtrl,
		controllerAs: 'vm',
		template: '<div mx-transclude></div>',
		transclude: true,
	});

	function MxContentWidgetViewNonVisualCtrl() {
		var vm = this;

		vm.$onInit = function () {
			vm.dataModel = vm.parameters;
		};

		return vm;
	}
})();
